import type { ReactElement, ReactNode } from 'react';

import { styled } from '../../styled';
import { Theme } from '../../theme/interface/detailed';

type Interface = {
	className: string;
	children: ReactNode;
};

const Component = ({ children, ...props }: Interface): ReactElement => {
	return (
		<div {...props}>
			<span>{children}</span>
		</div>
	);
};

export const QuestionnaireHeader = styled(Component)(
	({ theme }: { theme: Theme }) => theme.questionnaireField.header.questionnaireHeader
);
